module.exports = __webpack_public_path__ + "img/Fehlertyp2_Dok3.ea458893.jpg";